export default "__VITE_ASSET__o$O7cW4j__"